import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthHeadlineConverter extends CmsConverterService<FullWidthHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      icon: formData.st_icon?.value?.identifier ?? '',
      uuid: btoa(formData.st_headline?.value ?? '')
    }
  }
}

export const FULL_WIDTH_HEADLINE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CmsComponent>>('FullWidthHeadlineConverter')

export interface FullWidthHeadlineData extends ConvertedComponentData {
  headline: TextInput;
  icon: string;
  uuid: string;
}
